export default [
    {
        path: "/admin/organizational-structures",
        name: "organizational-structure",
        meta: { requiresAuth: true },
        component: () =>
            import("@/pages/human-resource/organizational-structure")
    }
];
